/* eslint-disable react/jsx-props-no-spreading */
import { Box, Tab, TabTypeMap, Tooltip, Typography } from '@mui/material';
import { DefaultComponentProps } from '@mui/material/OverridableComponent';

type ActiveTooltip = {
  title: string;
  option1: string;
  option2: string;
};

type Props = DefaultComponentProps<TabTypeMap> & {
  testid?: string;
  activeTooltip?: ActiveTooltip;
};

// https://github.com/mui/material-ui/issues/12597#issuecomment-455244379
function TabWithTooltip({
  testid,
  activeTooltip,
  disabled,
  ...tabProps
}: Props) {
  let tooltipContent: React.ReactNode = '';
  if (disabled) {
    tooltipContent =
      'You require a NorthStandard account to access these features.';
  } else if (activeTooltip) {
    tooltipContent = (
      <Box>
        <Typography fontWeight="bold">{activeTooltip.title}</Typography>
        <Typography variant="body2">{activeTooltip.option1}</Typography>
        <Typography variant="body2">{activeTooltip.option2}</Typography>
      </Box>
    );
  }

  return (
    <Tooltip title={tooltipContent}>
      <Box
        sx={{
          backgroundColor: disabled ? 'grey' : 'inherit',
          display: 'flex',
          width: '100%',
        }}
      >
        <Tab
          {...tabProps}
          disabled={disabled}
          data-testid={testid}
          aria-label={testid}
        />
      </Box>
    </Tooltip>
  );
}

export default TabWithTooltip;

TabWithTooltip.defaultProps = {
  testid: undefined,
  activeTooltip: undefined,
};
